import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

import { CoreMenuModule } from '@core/components';
import { CoreCommonModule } from '@core/common.module';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NavbarModule } from 'app/layout/components/navbar/navbar.module';
import { LucideAngularModule, User, Power, ChevronRight, Bell, BellRing, ChevronsUpDown, Sun, Moon } from 'lucide-angular';

import { VerticalMenuComponent } from 'app/layout/components/menu/vertical-menu/vertical-menu.component';
import { SidebarFooterComponent } from 'app/layout/components/menu/sidebar-footer/sidebar-footer.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelPropagation: false
};
@NgModule({
  declarations: [VerticalMenuComponent, SidebarFooterComponent],
  imports: [
    CoreMenuModule,
    CoreCommonModule,
    PerfectScrollbarModule,
    RouterModule,
    NgbModule,
    NavbarModule,
    LucideAngularModule.pick({ User, Power, ChevronRight, Bell, BellRing, ChevronsUpDown, Sun, Moon })
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ],
  exports: [VerticalMenuComponent, SidebarFooterComponent]
})
export class VerticalMenuModule {}
